// @ vendors
const { APIPost } = require('utilities/APIRequestHelper');
// @ commons
const apiURLBuilder = require('core/apiURLBuilder');
// @ constants
const gdprConsentsActions = require('actions/gdprConsents');
// @actions
const {
    hireContractFailure,
    hireContractSuccess,
} = require('actions/contracts');
const { setTermsAndCondsInfo } = require('actions/termsAndCondsInfo');
const signaturePatternActions = require('actions/signaturePattern');

const setDepositRenewal = (dispatch, data, getState) => {
    const operationProcessId = getState().contractualPolling.get('operationProcessId');
    const preContractualOperationProcessId = getState().preContractualPolling.get('operationProcessId');
    const immContracts = getState().contracts;
    const requestData = {
        query: {...data, dmsIdentifierContractual: operationProcessId, dmsIdentifierPrecontractual: preContractualOperationProcessId }
    };
    const contractType = immContracts.get('contract_type');
    const termsAndCondHiringData = [immContracts.get('hiring_data_contract').toJS()];

    return APIPost(dispatch, apiURLBuilder.getURL('hireDepositRenewal'), requestData)
        .then(response => {
            dispatch(hireContractSuccess(response));
            dispatch(setTermsAndCondsInfo(contractType, termsAndCondHiringData, operationProcessId));
        })
        .catch(response => {
            dispatch(hireContractFailure(response));
        });
};

const hireDepositRenewal = params => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        const data = Object.assign(params, { dataToken });
        dispatch(gdprConsentsActions.updateConsents(dataToken))
            .then(() => setDepositRenewal(dispatch, data, getState))
            .catch(response => {
                if(!!response.error) {
                    setDepositRenewal(dispatch, data, getState);
                } else {
                    throw response;
                }
            });
    };

    new Promise(function() {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    });
};

module.exports = {
    hireDepositRenewal,
};
